export default {"src":"/_next/static/media/1.4fb3721d.svg","height":171,"width":305,"blurWidth":0,"blurHeight":0};